export const getToken = () => window.localStorage.getItem("token");

export const parseJwt = (token) => {
  try {
    if (!token) return null;
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;

    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "=",
    );
    const jsonPayload = atob(padded);

    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

export const getTokenExpiry = (token = getToken()) => {
  const decoded = parseJwt(token);
  return decoded?.exp || null;
};

export const saveTokenExpiry = (token) => {
  const exp = getTokenExpiry(token);

  if (exp) {
    window.localStorage.setItem("tokenExpiry", String(exp));
  } else {
    window.localStorage.removeItem("tokenExpiry");
  }
};

export const isTokenExpired = () => {
  const token = getToken();

  if (!token) return true;

  const expiry = getTokenExpiry(token);

  if (!expiry) return true;

  return Math.floor(Date.now() / 1000) >= expiry;
};

export const handleExpiredSession = () => {
  window.localStorage.clear();
  window.localStorage.setItem(
    "sessionExpiredMessage",
    "Session expired. Please log in again.",
  );
  window.location.href = "/";
};
